export const HMREnum = {
  NotApplicable: 0,
  Homeless: 1,
  Migrant: 2,
  Runaway: 3,
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/HMREnum.js